// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__3TL6K","activeHandle":"RangeSlider_activeHandle__3wXsh"};